import { useState } from 'react'
import { LANG_TYPE } from '@/components/Layout/LangChange/constant'
import { getLocale, setLocale } from 'umi'

const useLangModel = () => {
  const [lang, setLang] = useState<LANG_TYPE>(getLocale())

  const changeLang = (lang: LANG_TYPE) => {
    setLang(lang)
    setLocale(lang, false)
  }

  return {
    lang,
    changeLang,
  }
}

export default useLangModel
